<div class="guide-panel"
     [class.screen-2]="step === 2"
     [class.has-promo]="promoVisible"
     *ngIf="isVisible"
     [@fadePanel]>

  <button class="close-btn" (click)="close()" aria-label="Close">
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
    </svg>
  </button>

  <!-- ── SCREEN 1: Choose your goal ── -->
  <ng-container *ngIf="step === 1">
    <div class="guide-header">
      <h2 class="guide-title">What brings you here?</h2>
      <p class="guide-subtitle">Choose your goal — we'll set up the map for you.</p>
    </div>

    <div class="container">
      <div class="tabs">
        <button class="tab" [class.selected]="selected === 'homebuyer'"  (click)="select('homebuyer')">Homebuyer</button>
        <button class="tab" [class.selected]="selected === 'realtor'"    (click)="select('realtor')">Realtor</button>
        <button class="tab" [class.selected]="selected === 'business'"   (click)="select('business')">Business</button>
        <button class="tab" [class.selected]="selected === 'researcher'" (click)="select('researcher')">Academia</button>
      </div>
    </div>
    <!-- Anna M said to rm this -->
    <!--    <span class="skip" (click)="skip()">Skip — I'll explore on my own</span>-->
  </ng-container>

  <!-- ── SCREEN 2: Checklist ── -->
  <ng-container *ngIf="step === 2">
    <div class="checklist">

      <div class="check-row" [class.done]="checklist.goalSet">
        <app-guide-checkbox [checked]="checklist.goalSet"></app-guide-checkbox>
        <div class="check-text-group">
          <span class="check-label">Set your goal</span>
        </div>
      </div>

      <div class="check-row layer-row" [class.done]="checklist.layerExplored"
           (click)="onLayerRowClick()"
           [matTooltip]="!checklist.layerExplored ? 'Find the highlighted layer in the right panel and click it' : ''"
           matTooltipPosition="above"
           matTooltipClass="guide-tooltip">
        <app-guide-checkbox [checked]="checklist.layerExplored"></app-guide-checkbox>
        <div class="check-text-group">
          <span class="check-label">Explore new data layer</span>
          <span class="click-badge" *ngIf="!checklist.layerExplored">click to highlight</span>
        </div>
      </div>

      <div class="check-row layer-row" [class.done]="checklist.zoomedIn"
           (click)="onZoomRowClick()"
           [matTooltip]="!checklist.zoomedIn ? 'Search for your city, or scroll to zoom in on the map' : ''"
           matTooltipPosition="above">
        <app-guide-checkbox [checked]="checklist.zoomedIn"></app-guide-checkbox>
        <div class="check-text-group">
          <span class="check-label">Zoom into your neighborhood</span>
        </div>
      </div>

      <div class="check-row" [class.done]="checklist.cellClicked"
           [matTooltip]="!checklist.cellClicked ? 'Click on any colored region on the map to see stats' : ''"
           matTooltipPosition="above">
        <app-guide-checkbox [checked]="checklist.cellClicked"></app-guide-checkbox>
        <div class="check-text-group">
          <span class="check-label">Click a cell — see local stats</span>
        </div>
      </div>

      <!-- 5th row — unlocks when all tasks done -->
      <div class="check-row promo-locked" [class.done]="promoVisible" [class.promo-unlocking]="allTasksDone">
        <app-guide-checkbox [checked]="promoVisible"></app-guide-checkbox>
        <div class="check-text-group">
          <span class="check-label">Get your promo code</span>
          <span class="lock-hint" *ngIf="!allTasksDone">Unlocks after steps above</span>
        </div>
      </div>

      <!-- Inline promo code — appears below checklist when all tasks done -->
      <div class="inline-promo" *ngIf="promoVisible" [@fadeIn]>
        <div class="inline-promo-header">
          <span class="promo-icon">🎁</span>
          <p class="promo-subtitle">Get a discount on your first subscription</p>
        </div>
        <div class="promo-code-block">
          <span class="promo-code-text">{{ promoCode }}</span>
          <button class="copy-btn" [class.copied]="promoCopied" (click)="copyPromo()">
            <ng-container *ngIf="!promoCopied">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" stroke-width="2"/>
                <path d="M5 15H4C2.9 15 2 14.1 2 13V4C2 2.9 2.9 2 4 2H13C14.1 2 15 2.9 15 4V5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              Copy
            </ng-container>
            <ng-container *ngIf="promoCopied">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              Copied!
            </ng-container>
          </button>
        </div>
      </div>

    </div>
  </ng-container>

</div>
